﻿window.validation = function () {
    let dateMessage = "";
    let timeMessage = "";
    let datetimeMessage = "";
    let requiredMessage = "";

    return {
        getConfiguration: function() {
            return {
                rules: {
                    date: function (input) {
                        if (input.is("[data-role=datepicker]")) {
                            return kendo.parseDate(input.val()) !== null;
                        }
                        return true;
                    },
                    time: function (input) {
                        if (input.is("[data-role=timepicker]")) {
                            return kendo.parseDate(input.val(), "HH:mm") !== null;
                        }
                        return true;
                    },
                    datetime: function (input) {
                        if (input.is("[data-role=datetimepicker]")) {
                            return kendo.parseDate(input.val()) !== null;
                        }
                        return true;
                    },
                    required: function (input) {
                        return input.val() !== null && input.val() !== '';
                    }
                },
                messages: {
                    required: requiredMessage,
                    date: dateMessage,
                    time: timeMessage,
                    datetime: datetimeMessage
                }
            };
        },

        initialize: function (localizedRequiredMessage, localizedDateMessage, localizedTimeMessage, localizedDateTimeMessage) {
            requiredMessage = localizedRequiredMessage;
            dateMessage = localizedDateMessage;
            timeMessage = localizedTimeMessage;
            datetimeMessage = localizedDateTimeMessage;
        }
    }
}();